import * as React from 'react';
import { Link, graphql } from 'gatsby';
import { Box, Container, Flex, Stack, Image } from '@chakra-ui/react';
// import { FaEnvelope, FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import parse from 'html-react-parser';
import SEO from '../components/seo';
import Layout from '../components/layout';
import '../styles/article.scss';

const Post = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  const post = props.data.wpPost;
  return (
    <Layout>
      <SEO
        title="Osensa Media | Ostara"
        description="Optimize plant nutrition by increasing uptake and reducing runoff with enhanced efficiency fertilizers designed for today's data-driven and environmentally aware growers."
        image="https://pacemediafiles.s3.us-west-2.amazonaws.com/ostara/ostara_logo.png"
        keywords="Enhanced Efficiency Fertilizers"
      />
      <main className="media-page">
        <Box w="100%" p={4} className="media-hero-container">
          <Container maxW={1400}>
            <Box
              display="flex"
              flexDirection={['column', 'column', 'column', 'row']}
              justifyContent="space-between"
              paddingTop={[0, 0, 10, 50]}
            >
              <Box
                marginTop={[5, 5, 5, 0]}
                w={['100%', '100%', '100%', '46.5%']}
              >
                <Stack
                  className="media-hero-container--title"
                  maxW="50rem"
                  spacing={6}
                >
                  <Link to="/media">Back</Link>
                  <h2>{post.title}</h2>
                </Stack>
              </Box>
              <Stack
                spacing={[4, 6, 4, 6, 8]}
                w={['100%', '100%', '100%', '46.5%']}
              >
                <Box className="media-hero-img">
                  {post.heroImage.heroImage ? (
                    <Image
                      className="hero-img"
                      placeholder="transparent"
                      src={post.heroImage.heroImage.sourceUrl}
                      alt="article-thumbnail"
                    />
                  ) : null}
                </Box>
              </Stack>
            </Box>
          </Container>
        </Box>
        <Box w="100%" className="media-body-container">
          <Flex direction="column">
            <Container
              marginTop={[10, 10, 10, 100]}
              marginBottom={[10, 10, 10, 100]}
              maxW={1400}
            >
              {parse(post.content)}
            </Container>
          </Flex>
        </Box>

        {/* <Box w="100%" className="media-body-container2">
          <Container maxW={1400} marginTop={20}>
            <Flex
              className="media-body-container2--heading"
              alignItems="center"
              justifyContent="space-between"
            >
              <h2>Related media</h2>
              <CustomButton to="/media" maxW={230}>
                VIEW ALL
              </CustomButton>
            </Flex>
            <Flex justifyContent="space-between" flexWrap="wrap">
              <div className="related-items">
                <StaticImage
                  src="../images/article-sample1.png"
                  alt="Crop Data Overlay img"
                  className="articles-thumbnail"
                  height={235}
                />
                <p>
                  Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed
                  Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua.
                </p>
                <Link to="/articles">Read</Link>
              </div>
              <div className="related-items">
                <StaticImage
                  src="../images/article-sample2.png"
                  alt="Crop Data Overlay img"
                  className="articles-thumbnail"
                  height={235}
                />
                <p>
                  Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed
                  Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua.
                </p>
                <Link to="/articles">Read</Link>
              </div>
              <div className="related-items">
                <StaticImage
                  src="../images/article-sample3.png"
                  alt="Crop Data Overlay img"
                  className="articles-thumbnail"
                  height={235}
                />
                <p>
                  Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed
                  Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua.
                </p>
                <Link to="/articles">Read</Link>
              </div>
            </Flex>
          </Container>
        </Box> */}
      </main>
    </Layout>
  );
};

export default Post;
export const postQuery = graphql`
  query ($id: String) {
    wpPost(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      date(formatString: "DD MMMM YYYY")
      featuredImage {
        node {
          sourceUrl
        }
      }
      heroImage {
        heroImage {
          sourceUrl
        }
      }
    }
  }
`;
